import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class CouponService {
  private apiPrefix = '/admin/coupon';

  constructor(
    private api: ApiService
  ) {
  }

  listCoupons(qs = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  createCoupon(data: object): Observable<any> {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  updateCoupon(id: number, data: object): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteCoupon(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  toggleActiveStatus(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/toggle-active`, {})
  }
}
